/**
 * iOS Does not resize viewport upon opening of keyboard... We need to make a best guess to polyfill/fix that behaviour.
 *
 * Use this on focus of an input field to make corrections.
 *
 * https://stackoverflow.com/questions/39417778/iphone-safari-not-resizing-viewport-on-keyboard-open
 */
const isiOSKeyboardOpen = () => {
	if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
		const cachedScroll = window.scrollTop;
		window.scrollTop = 10;
		const keyboardShown = window.scrollTop > 0;
		window.scrollTop = cachedScroll;

		return keyboardShown;
	} else {
		return false;
	}
};

export default isiOSKeyboardOpen;



// WEBPACK FOOTER //
// ./src/isiOSKeyboardOpen.js